"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnConfig = void 0;
const tooltip_1 = require("@components/tooltip");
const _utils_1 = require("@utils");
const numbers_1 = require("@utils/object/numbers");
const react_1 = __importDefault(require("react"));
const handleClick = (fromAddress) => {
    if (!fromAddress) {
        return;
    }
    (0, _utils_1.copyToClipboard)(fromAddress);
};
const getColumnConfig = () => [
    {
        title: "Date",
        width: 1.3,
        cellRender: ({ date }) => (0, _utils_1.formatDate)(Number(date)),
    },
    {
        title: "From",
        width: 1.2,
        cellRender: ({ fromAddress }) => (react_1.default.createElement(tooltip_1.Tooltip, { content: fromAddress },
            react_1.default.createElement("button", { className: "copyButton", onClick: () => handleClick(fromAddress) }, (0, _utils_1.formatAddress)(fromAddress)))),
    },
    {
        title: "To",
        width: 1.2,
        cellRender: ({ toAddress }) => (react_1.default.createElement(tooltip_1.Tooltip, { content: toAddress },
            react_1.default.createElement("button", { className: "copyButton", onClick: () => handleClick(toAddress) }, (0, _utils_1.formatAddress)(toAddress)))),
    },
    {
        title: "Amount",
        width: 1,
        cellRender: ({ quant, tokenDecimal }) => (0, numbers_1.formatAndNormalize)(quant, tokenDecimal),
    },
    {
        title: "Currency",
        width: 1,
        cellRender: ({ currency }) => currency,
    },
    {
        title: "Hash",
        width: 1.1,
        cellRender: ({ hash }) => (react_1.default.createElement(tooltip_1.Tooltip, { content: hash },
            react_1.default.createElement("button", { className: "copyButton", onClick: () => handleClick(hash) }, (0, _utils_1.formatAddress)(hash)))),
    },
];
exports.getColumnConfig = getColumnConfig;
